export const AI_CONFIG_ID = "ai-configuration"
export const AI_CONFIG_AUDIT_TYPE = "aiConfig"

export const AI_MODEL_SIZE = {
    SMALL: "small",
    MEDIUM: "medium",
    LARGE: "large",
}

export const AI_REASONING_EFFORT = {
    NONE: "none",
    LOW: "low",
    MEDIUM: "medium",
    HIGH: "high",
}

export const REASONING_EFFORT_OPTIONS = Object.values(AI_REASONING_EFFORT)

export const UNSAFE_AI_MODEL_DEFAULTS = {
    models: ["gpt-5.4-nano", "gpt-5.4-mini", "gpt-5.5"],
    [AI_MODEL_SIZE.SMALL]: "gpt-5.4-nano",
    [AI_MODEL_SIZE.MEDIUM]: "gpt-5.4-mini",
    [AI_MODEL_SIZE.LARGE]: "gpt-5.5",
    reasoningEffortSmall: AI_REASONING_EFFORT.NONE,
    reasoningEffortMedium: AI_REASONING_EFFORT.NONE,
    reasoningEffortLarge: AI_REASONING_EFFORT.NONE,
}

export const REASONING = {
    LOW: "low",
    MEDIUM: "medium",
    HIGH: "high",
}

export const DEFAULT_REASONING_BY_SIZE = {
    large: REASONING.HIGH,
    medium: REASONING.MEDIUM,
    small: REASONING.LOW,
}
